module.exports = __webpack_public_path__ + "img/arrow_up_white_32dp.97954ac6.png";